"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.RangeValue = exports.RangeSliderWrapper = exports.Slider = exports.Bubble = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Bubble = styled_components_1.default.output `
  background: ${(props) => (props.disabled ? colors_1.GREY1 : colors_1.DARK_GREEN)};
  color: white;
  padding: 8px 18px;
  height: 16px;
  position: absolute;
  left: ${(props) => props.position};
  transform: translateX(-50%);
`;
exports.Slider = styled_components_1.default.input `
  width: 100%;
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  background: linear-gradient(
    90deg,
    ${(props) => (props.disabled ? colors_1.GREY1 : colors_1.DARK_GREEN)}
      ${(props) => ((props.value - props.min) * 100) / (props.max - props.min) + "%"},
    ${(props) => (props.disabled ? colors_1.GREY1 : colors_1.PALE_GREEN)}
      ${(props) => ((props.value - props.min) * 100) / (props.max - props.min) + 0.1 + "%"}
  );

  background-color: ${colors_1.GREY1};

  height: 8px;
  border-radius: 8px;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid ${(props) => (props.disabled ? colors_1.GREY1 : colors_1.DARK_GREEN)};
    background-color: ${(props) => (props.disabled ? colors_1.GREY1 : colors_1.DARK_GREEN)};
    border-radius: 8px;
    cursor: pointer;
  }
`;
exports.RangeSliderWrapper = styled_components_1.default.div `
  position: relative;
  width: 100%;
`;
exports.RangeValue = styled_components_1.default.label `
  margin: 0 8px;
  font-weight: bold;
`;
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
`;
//# sourceMappingURL=RangeSliderSingular.styles.js.map